export default "__VITE_ASSET__BOOQ2bSl__"